export default __webpack_public_path__ + "static/media/fancy-text-img-01.37df550c.jpg";